<template>
  <div>
    <div v-if="audio.preview" class="preview-box">
      <audio class="audio-player" controls :src="audio.preview"></audio>
      <div class="preview-footer">
        <div class="name v-ellipsis">{{ audio.name }}</div>
        <i @click.stop="openWindow(audio.preview)" class="operate-btn el-icon-zoom-in"></i>
        <i @click.stop="deleteFile" class="operate-btn el-icon-delete"></i>
      </div>
    </div>

    <div v-if="!audio.preview" @click="chooseFile" class="upload-btn v-col v-center" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)">
      <i class="icon el-icon-plus"></i>
    </div>

    <upload-dialog v-if="isShowUploadDialog" :show.sync="isShowUploadDialog" type="audio" @change="handleChange"></upload-dialog>
  </div>
</template>

<script>
import uploadDialog from './components/upload-dialog';

export default {
  components: { uploadDialog },

  props: ['id'],

  data() {
    return {
      audio: {},
      loading: false,
      isShowUploadDialog: false,
    };
  },

  model: {
    prop: 'id',
    event: 'change',
  },

  created() {
    if (this.id) {
      this.getPreview();
    }
  },

  watch: {
    id: function(val) {
      if (typeof val == 'number' && val) {
        this.getPreview();
      }
    },
  },

  methods: {
    //根据id获取素材
    async getPreview() {
      this.loading = true;
      try {
        let res = await this.api.media.getPreview({ ids: [this.id] });
        this.audio = res.data[this.id];
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //选择文件
    chooseFile() {
      this.isShowUploadDialog = true;
    },

    //删除
    deleteFile() {
      this.$emit('change', '');
      this.audio = {};
    },

    //监听选择文件
    handleChange(audios) {
      let { key, preview, name, id } = audios[0];
      let audio = { key, preview, name, id };
      this.audio = audio;
      this.$emit('change', id);
    },

    //新窗口打开
    openWindow(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  position: relative;
  width: 300px;
  height: 60px;
  line-height: 1;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 10px 0;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-box {
  position: relative;
  width: 300px;
  line-height: 1;
}

.preview-box .preview-footer {
  display: flex;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  align-items: center;
  transition: all 0.3s ease;
}

.preview-box .preview-footer .name {
  flex: 1;
  font-size: 12px;
  padding: 0 10px;
  height: 25px;
}

.preview-box .preview-footer .operate-btn {
  color: #fff;
  margin-right: 10px;
  cursor: pointer;
  line-height: 25px;
}

.preview-box .audio-player {
  height: 40px;
}
</style>
